var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr'),_c('div',{staticClass:"mt-3"},[_c('b-skeleton-table',{attrs:{"rows":7,"columns":8,"table-props":{ bordered: true, striped: true }}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }